import './Arquitectura.css';
import React from "react";
import Arquitectura0 from '../../assets/Industries/Arquitectura/arquitectura.png';
import Arquitectura1 from '../../assets/Industries/Arquitectura/arquitectura1.png';
import Arquitectura2 from '../../assets/Industries/Arquitectura/arquitectura2.png';
import Arquitectura3 from '../../assets/Industries/Arquitectura/arquitectura3.png';
import Arquitectura4 from '../../assets/Industries/Arquitectura/arquitectura4.png';
import Arquitectura5 from '../../assets/Industries/Arquitectura/arquitectura5.png';
import Arquitectura6 from '../../assets/Industries/Arquitectura/arquitectura6.png';
import Arquitectura7 from '../../assets/Industries/Arquitectura/arquitectura7.png';
import Arquitectura8 from '../../assets/Industries/Arquitectura/arquitectura8.png';
import Arquitectura9 from '../../assets/Industries/Arquitectura/arquitectura9.png';
import Arquitectura10 from '../../assets/Industries/Arquitectura/arquitectura10.png';
import Arquitectura11 from '../../assets/Industries/Arquitectura/arquitectura11.png';
import Arquitectura12 from '../../assets/Industries/Arquitectura/arquitectura12.png';

const images = [
    { src: Arquitectura1, text: "Wukesong Basketball Hall", link: "https://maps.app.goo.gl/yzkQg1WfvgFMAAeK9" },
    { src: Arquitectura2, text: "Museo Nacional de China", link: "https://maps.app.goo.gl/MT4BLyQfoF1YkJ9a7" },
    { src: Arquitectura3, text: "Teatro Nacional de China", link: "https://maps.app.goo.gl/Ki9gorXN89S8nktF7" },
    { src: Arquitectura4, text: "Shanghai Center Building", link: "https://maps.app.goo.gl/NdF2EGDobijXHLec6" },
    { src: Arquitectura5, text: "Japan Cocoon Building", link: "https://g.co/kgs/ebQtgR6" },
    { src: Arquitectura6, text: "Vietnam Keangnam Sign Tower", link: "https://g.co/kgs/Miipa6D" },
    { src: Arquitectura7, text: "Canada L Tower", link: "https://maps.app.goo.gl/6DVQUsqrY8RN6XgD8" },
    { src: Arquitectura8, text: "Asian Games City", link: "https://maps.app.goo.gl/G5BfjttRjmcSNMtE6" },
    { src: Arquitectura9, text: "National South China Sea Museum", link: "https://maps.app.goo.gl/183rSezg3r6SGt6E7" },
    { src: Arquitectura10, text: "Shenzhen Stock Exchange", link: "https://maps.app.goo.gl/LpXmQzx31CuYspjx8" },
    { src: Arquitectura11, text: "Xi'an Silk Road Station", link: "https://maps.app.goo.gl/UUY9Q2UkmdP2q95D7" },
    { src: Arquitectura12, text: "Beijing University", link: "https://maps.app.goo.gl/PrgtiiZDczAviMDK7" }
];

function Arquitectura() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-header">
                <div className="arquitectura-texto">
                    <h2>Arquitectura</h2>
                    <div className="underline"></div>
                    <p>
                        Nuestra empresa se especializa en soluciones arquitectónicas avanzadas,
                        brindando materiales de alta calidad para la construcción y el diseño estructural.
                        Con un enfoque en la innovación y la sostenibilidad, creamos productos que
                        cumplen con los más altos estándares de la industria.
                    </p>
                </div>
                <div className="arquitectura-imagen">
                    <img src={Arquitectura0} alt="Arquitectura" />
                </div>
            </div>

            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                            <img src={item.src} alt={`Arquitectura ${index + 1}`} />
                        </a>
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Arquitectura;
